<div class="rephrase-options-container">
  <mat-form-field>
    <mat-label>{{'Options.Tone' | translate }}</mat-label>
    <mat-select [(ngModel)]="rephraseOptions.selectedTone" name="tone">
      <mat-select-trigger>
        {{ 'Options.ToneSelection.' + rephraseOptions.selectedTone | translate }}
      </mat-select-trigger>
      @for (tone of rephraseOptions.toneOptions; track tone) {
        <mat-option [value]="tone">
          {{ 'Options.ToneSelection.' + tone | translate }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{'Options.WritingStyle' | translate }}</mat-label>
    <mat-select [(ngModel)]="rephraseOptions.selectedWritingStyle" name="writingStyle">
      <mat-select-trigger>
        {{ 'Options.WritingStyleSelection.' + rephraseOptions.selectedWritingStyle | translate }}
      </mat-select-trigger>
      @for (style of rephraseOptions.writingStyleOptions; track style) {
        <mat-option [value]="style">
          {{ 'Options.WritingStyleSelection.' + style | translate }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
